import * as React from 'react'

import NotFound from 'modules/core/components/NotFound'

export interface RenderProps {
  isAuthorized: boolean
}
interface Props {
  authorizeFn?: () => boolean
}

const AuthorizeUser = ({
  children,
  authorizeFn,
}: React.PropsWithChildren<Props> | (Props & React.ConsumerProps<{ isAuthorized: boolean }>)) => {
  const isAuthorized = authorizeFn ? authorizeFn() : false

  if (typeof children === 'function') {
    return <>{children({ isAuthorized })}</>
  }

  if (!isAuthorized) return <NotFound />

  return <>{children}</>
}

export default AuthorizeUser
